import { render, staticRenderFns } from "./Productdetailsingle.vue?vue&type=template&id=579b14a1&"
import script from "./Productdetailsingle.vue?vue&type=script&lang=js&"
export * from "./Productdetailsingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports